(() => {
  if (window.__contactSubmissionFormInitialized) return;
  window.__contactSubmissionFormInitialized = true;

  const initialize = () => {
    document.querySelectorAll('[data-contact-submission-form]').forEach((form) => {
      const submit = form.querySelector('[type="submit"]');
      const success = form.querySelector('[data-contact-success]');
      const error = form.querySelector('[data-contact-error]');
      const params = new URLSearchParams(window.location.search);
      const receiptForm = form.dataset.contactReceiptForm;
      const isThisReceipt = !params.get('contact_form') || params.get('contact_form') === receiptForm;

      if (isThisReceipt && params.get('submitted') === '1' && success) {
        success.hidden = false;
        success.focus();
      }
      if (isThisReceipt && params.get('contact_error') && error) {
        error.hidden = false;
        error.focus();
      }

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (form.dataset.submitting === 'true') return;

        form.dataset.submitting = 'true';
        if (submit) submit.disabled = true;
        if (error) error.hidden = true;

        try {
          const response = await fetch(form.action, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
            body: new URLSearchParams(new FormData(form)),
          });
          const result = await response.json().catch(() => null);
          if (result?.outcome === 'submitted' && typeof result.redirectTo === 'string') {
            window.location.assign(result.redirectTo);
            return;
          }
        } catch (_error) {
          // The generic notice below is intentionally the only user-facing failure detail.
        }

        form.dataset.submitting = 'false';
        if (submit) submit.disabled = false;
        if (error) {
          error.hidden = false;
          error.focus();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
